import { humanize } from "../../../utils/words";
import Button from "../../common/Button";

function SchedulesTable({ userData, isLoading, credential, schedulesByCredential, handleUpdateScheduleButtonClick, handleDeleteSchedule, handleUpdateSchedule }) {
  const toggleScheduleState = (action, schedule) => { 
    schedule.action = action;
    handleUpdateSchedule(schedule);
  }

  return (
    <tr className="schedules-list" key={credential.id + '-details'}>
      <td colSpan={7}>
        <strong>Schedules</strong>
        <table>
          <thead>
            <tr>
              <th>Service</th>
              <th>Schedule</th>
              <th>Timezone</th>
              <th>Status</th>
              { userData?.can_schedule && <th>Actions</th> }
            </tr>
          </thead>
          <tbody>
            {(schedulesByCredential[credential.id] || []).length === 0 ? (
                <tr><td colSpan={5}><center>No Data Found</center></td></tr>
            ) : (
              schedulesByCredential[credential.id].map(sch => (
                <tr key={sch.id}>
                  <td>{humanize(sch.body.service_id) || '-'}</td>
                  <td>{sch.schedule}</td>
                  <td>{sch.timezone}</td>
                  <td>{sch.status}</td>
                  { userData?.can_schedule && <td>
                    <div>
                      { sch.status === 'ENABLED' && <Button className="normal danger" isLoading={isLoading} label="Pause" onClick={() => toggleScheduleState('pause', sch)} /> }
                      { sch.status === 'PAUSED' && <Button className="normal" isLoading={isLoading} label="Resume" onClick={() => toggleScheduleState('resume', sch)} /> }

                      <Button className="normal" isLoading={isLoading} label="Update" onClick={() => handleUpdateScheduleButtonClick(sch)} />
                      <Button className="normal danger" isLoading={isLoading} label="Delete" onClick={() => handleDeleteSchedule(sch.name)} />
                    </div>
                  </td> }
                </tr>
              ))
            )}
          </tbody>
        </table>
      </td>
    </tr>
  );
}

export default SchedulesTable;